import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';
import supplierApis from './apis';
import { ISagaFunc } from 'services/actionConfigs';
import { GetSupplierListParams } from './constants';

const getSupplierList: ISagaFunc<GetSupplierListParams> = function* ({ payload }) {
  yield delay(200);
  try {
    const response = yield call(supplierApis.supplier.getList, payload);
    yield put(actions.async.getSupplierList.success(response.data.data));
  } catch (error) {
    yield put(actions.async.getSupplierList.fail({}));
  }
};

export default function* sagas() {
  yield takeLatest(actions.async.getSupplierList.fetch, getSupplierList);
}
